import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
export default {
  install(Vue) {
    Vue.prototype.$firebase = firebase.initializeApp({
      apiKey: "AIzaSyCedJ7tXdoEazKDsGcfhYo5LKnyY2sAeHA",
      authDomain: "dotronglong.firebaseapp.com",
      databaseURL: "https://dotronglong.firebaseio.com",
      projectId: "dotronglong",
      storageBucket: "dotronglong.appspot.com",
      messagingSenderId: "65418911628",
      appId: "1:65418911628:web:866cf6d5010cdbff98c0a9"
    });
  }
};
